__turbopack_context__.v({
  "active-pagination-button": "styles-module-scss-module__derRNq__active-pagination-button",
  "ellipsis-pagination-button": "styles-module-scss-module__derRNq__ellipsis-pagination-button",
  "first-pagination-button": "styles-module-scss-module__derRNq__first-pagination-button",
  "last-pagination-button": "styles-module-scss-module__derRNq__last-pagination-button",
  "next-pagination-button": "styles-module-scss-module__derRNq__next-pagination-button",
  "paginationWrapper": "styles-module-scss-module__derRNq__paginationWrapper",
  "prev-pagination-button": "styles-module-scss-module__derRNq__prev-pagination-button",
});
